/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import {
    Flex, Text, Button, Link, Grid, Box
} from 'components/ui';
import RwdAddressForm from 'components/Addresses/RwdAddressForm';
import AccordionButton from 'components/FrictionlessCheckout/LayoutCard/AccordionButton';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';
import userUtils from 'utils/User';
import Modal from 'components/Modal/Modal';
import FormsUtils from 'utils/Forms';
import UIUtils from 'utils/UI';

import orderUtils from 'utils/Order';
import errorsUtils from 'utils/Errors';
import Debounce from 'utils/Debounce';
import Location from 'utils/Location';
import processEvent from 'analytics/processEvent';
import analyticsConsts from 'analytics/constants';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import addressUtils from 'utils/Address';
import cookieUtils from 'utils/Cookies';
import userActions from 'actions/UserActions';
import FrictionlessUtils from 'utils/FrictionlessCheckout';
import ErrorList from 'components/ErrorList';
import FrictionlessCheckoutBindings from 'analytics/bindingMethods/pages/FrictionlessCheckout/FrictionlessCheckoutBindings';
import { SECTION_NAMES } from 'constants/frictionlessCheckout';
import { addressApiCall } from 'services/Checkout';

const { formatZipCode } = addressUtils;
const { isSMUI } = UIUtils;

const getCountryFromAddress = (address, shipCountry) => {
    const country = address?.country;

    if (address && country) {
        return country;
    } else {
        return shipCountry;
    }
};
class ShipAddressForm extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            countryList: null,
            isDefault: this.props.isDefaultChecked
        };
        this.addressForm = React.createRef();
    }

    componentDidMount() {
        this.props.togglePlaceOrderDisabled(true);
        this.setAnalytics();
    }

    setAnalytics = () => {
        const { localization, address, isGiftCardSection, hasUserOpenedAddressForm } = this.props;
        const { editShipAddress, addNewShipAddress } = localization;
        const linkName = this.props.address ? editShipAddress : addNewShipAddress;
        !this.props.isCollapsed &&
            FrictionlessCheckoutBindings.setAddOrEditShippingAddressAnalytics(!!address, linkName, isGiftCardSection, hasUserOpenedAddressForm);
    };

    closeShipAddressForm = () => {
        if (isSMUI()) {
            this.setState({ isOpen: false }, this.props.cancelCallback());
        } else {
            this.props.cancelCallback();
        }
    };

    setAnalyticsAndErrors = (sectionName, errors) => {
        if (Object.keys(errors)?.length > 0) {
            FrictionlessCheckoutBindings.setSectionLevelErrorAnalytics(sectionName, errors[sectionName]);
            this.props.setCheckoutSectionErrors(errors);
        }
    };

    handleIsDefault = () => {
        this.setState({ isDefault: !this.state.isDefault });

        //Analytics
        if (!this.state.isDefault) {
            processEvent.process(analyticsConsts.LINK_TRACKING_EVENT, {
                data: {
                    eventStrings: [analyticsConsts.Event.EVENT_71, 'event121'],
                    linkName: 'D=c55',
                    pageDetail: digitalData.page.pageInfo.pageName,
                    actionInfo: `${analyticsConsts.PAGE_TYPES.CHECKOUT}:default shipping address`,
                    previousPage: 'checkout:shipping:n/a:*'
                }
            });
        }
    };

    showError = (message, value, errorKey) => {
        const sectionName = this.props.isGiftCardSection ? SECTION_NAMES.GIFT_CARD_DELIVERY : SECTION_NAMES.DELIVER_TO;

        if (!this.addressForm.handleResponseError(message, value, errorKey)) {
            if (message) {
                FrictionlessCheckoutBindings.setSectionLevelErrorAnalytics(sectionName, message);
                const errors = FrictionlessUtils.setDeliverToErrors(message, this.props.isGiftCardSection);
                this.props.setCheckoutSectionErrors(errors);
            }

            let { errorMessages } = this.state;
            errorMessages = (errorMessages || []).slice();

            if (errorMessages.indexOf(message) < 0) {
                this.setState({ errorMessages: errorMessages.concat([message]) });
            }
        }
    };

    initPaze = email => {
        if (
            Sephora.configurationSettings.globalPazeOptionEnabled &&
            Sephora.configurationSettings.guestCheckoutPazeOptionEnabled &&
            email &&
            this.props.isGuestCheckout
        ) {
            userActions.initPaze(email);
        }
    };

    validateAddressForm = e => {
        e.preventDefault();
        const sectionName = this.props.isGiftCardSection ? SECTION_NAMES.GIFT_CARD_DELIVERY : SECTION_NAMES.DELIVER_TO;
        const email = this.addressForm?.emailInput?.state?.value;
        this.setState({ errorMessages: '' });

        // Initialize Paze for guest checkout
        this.initPaze(email);

        const isValid = this.addressForm.validateForm();

        if (isValid) {
            this.props.clearNamedSectionErrors([sectionName]);
            this.createAddress();
        } else {
            FrictionlessCheckoutBindings.setSectionLevelErrorAnalytics(sectionName);
            this.props.setCheckoutSectionErrors({ [sectionName]: true });
        }
    };
    validateAddressFormDebounce = Debounce.preventDoubleClick(this.validateAddressForm);

    createAddress = () => {
        const { getData, isAddressVerified, hasAVS } = this.addressForm;
        const { address, isNCR } = this.props;
        const _deletedFromAddressBook = address?._deletedFromAddressBook || false;

        const newAddressData = getData();
        const dataToSend = Object.assign({}, newAddressData, {
            isDefaultAddress: this.state.isDefault,
            shippingGroupId: this.props.shippingGroupId,
            addressValidated: hasAVS() ? isAddressVerified() : undefined
        });

        const orderId = orderUtils.getOrderId();
        const isSameDayOder = orderUtils.isSdd();
        let apiToCall;
        const callback = this.validateAddress;

        //if props.address exists then user is in edit mode
        if (isNCR && address && !_deletedFromAddressBook) {
            apiToCall = this.props.updateAddress;
            dataToSend.replacementOrderId = orderId;
        } else if (isNCR) {
            apiToCall = this.props.shippingAddress;
            delete dataToSend.addressId;
            dataToSend.replacementOrderId = orderId;
        } else if (address) {
            apiToCall = this.props.updateShippingAddress;
        } else {
            apiToCall = this.props.createShippingAddress;
        }

        if (apiToCall === this.props.createShippingAddress && isSameDayOder) {
            const postalCode = formatZipCode(dataToSend.address.postalCode);

            addressApiCall({
                dataToSend,
                apiToCall,
                callback: results => {
                    this.props
                        .updatePreferredZipCode({ postalCode })
                        .then(zipCodeData => {
                            const zipData = {
                                preferredZipCode: zipCodeData.zipCode,
                                encryptedStoreIds: zipCodeData.encryptedStoreIds
                            };
                            Storage.session.setItem(LOCAL_STORAGE.PREFERRED_ZIP_CODE, zipData);

                            if (Sephora.configurationSettings.setZipStoreCookie) {
                                cookieUtils.write('sameDayZipcodeCookie', zipCodeData.zipCode, null, false, false);
                            }
                        })
                        .catch(error => errorsUtils.collectAndValidateBackEndErrors(error, this));
                    callback(results, dataToSend);
                },
                isNCR,
                setAnalyticsAndErrors: this.setAnalyticsAndErrors,
                comp: this
            });
        } else {
            addressApiCall({
                dataToSend,
                apiToCall,
                callback,
                isNCR,
                setAnalyticsAndErrors: this.setAnalyticsAndErrors,
                comp: this
            });
        }
    };

    sectionSaved = () => {
        if (isSMUI()) {
            this.setState({ isOpen: false }, () => this.props.sectionSaved(Location.getLocation().pathname));
        } else {
            this.props.sectionSaved(Location.getLocation().pathname);
        }
    };

    validateAddress = (data, uiAddress) => {
        const { addressId } = data;

        if (isSMUI()) {
            this.setState({ isOpen: false }, () => this.props.validateAddress(addressId, uiAddress));
        } else {
            this.props.validateAddress(addressId, uiAddress);
        }

        if (this.props.isNCR) {
            this.props.setLastUsedShippingAddressId(addressId);
        }
    };

    render() {
        const shipCountry = userUtils.getShippingCountry().countryCode;
        const {
            localization: {
                setAsDefaultCheckbox, editShipAddress, addNewShipAddress, cancelButton, saveContinueButton
            },
            children
        } = this.props;

        const shipAddressFormContainer = (
            <div id='ship_address_form'>
                <RwdAddressForm
                    editStore={FormsUtils.getStoreEditSectionName(FormsUtils.FORMS.CHECKOUT.SHIPPING_ADDRESS, this.props.isNewUser)}
                    hasGridLayout={true}
                    isEditMode={!!this.props.address}
                    address={this.props.address}
                    country={getCountryFromAddress(this.props.address, shipCountry)}
                    isCheckout={true}
                    isGuestCheckout={this.props.isGuestCheckout}
                    isCountryFieldHidden={true}
                    showAddress2Input={true}
                    isFrictionless={true}
                    onRef={comp => {
                        this.addressForm = comp;
                    }}
                />

                {children && (
                    <Box
                        marginBottom={this.props.isFirstAddress ? 0 : 3}
                        marginTop={0}
                    >
                        {children}
                    </Box>
                )}

                <div style={this.props.isFirstAddress ? { display: 'none' } : null}>
                    <Checkbox
                        checked={this.state.isDefault}
                        onClick={this.handleIsDefault}
                        name='is_default'
                    >
                        {setAsDefaultCheckbox}
                    </Checkbox>
                </div>
            </div>
        );

        return isSMUI() && !this.props.isFirstAddress ? (
            <Modal
                isOpen={this.state.isOpen}
                onDismiss={this.closeShipAddressForm}
            >
                <Modal.Header>
                    <Modal.Title>{this.props.address ? editShipAddress : addNewShipAddress}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorList errorMessages={this.state.errorMessages} />
                    {shipAddressFormContainer}
                </Modal.Body>
                <Modal.Footer>
                    <Grid gap={4}>
                        <Button
                            variant='secondary'
                            block={true}
                            onClick={this.closeShipAddressForm}
                            children={cancelButton}
                        />
                        <Button
                            variant='primary'
                            block={true}
                            onClick={this.validateAddressFormDebounce}
                            children={saveContinueButton}
                        />
                    </Grid>
                </Modal.Footer>
            </Modal>
        ) : (
            <div>
                {this.props.isFirstAddress || (
                    <Text
                        is='h2'
                        lineHeight='tight'
                        fontWeight='bold'
                        fontSize='md'
                        marginBottom={4}
                    >
                        {this.props.address ? editShipAddress : addNewShipAddress}
                    </Text>
                )}

                {shipAddressFormContainer}

                <Flex alignItems='baseline'>
                    <AccordionButton onClick={this.validateAddressFormDebounce} />
                    {this.props.showCancelButtonInChild && (
                        <Link
                            color='blue'
                            padding={3}
                            marginLeft={3}
                            onClick={this.closeShipAddressForm}
                        >
                            {cancelButton}
                        </Link>
                    )}
                </Flex>
            </div>
        );
    }
}

export default wrapComponent(ShipAddressForm, 'ShipAddressForm');
